import { render, staticRenderFns } from "./business-manage.vue?vue&type=template&id=50f44e33&scoped=true&"
import script from "./business-manage.vue?vue&type=script&lang=js&"
export * from "./business-manage.vue?vue&type=script&lang=js&"
import style0 from "./business-manage.vue?vue&type=style&index=0&id=50f44e33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f44e33",
  null
  
)

export default component.exports